import axios from "axios";
import { getConfigTenant, isCorpTenant } from "@capone/common";
import {
  UntypedExperiment,
  CorpExperimentsMap,
  ConsumerExperimentsMap,
  BUSINESS_EXPERIMENT_VARIANTS,
} from "../types";
import { config } from "./config";

interface CombinedMaps extends CorpExperimentsMap, ConsumerExperimentsMap {}

const END_POINT = `/api/v0/experiments/active`;
const JsonExperiments = new Set([
  "corp-traveler-maintenance",
  "cap1-portal-maintenance",
  "corp-free-fda-account-preselect",
]);

const createExperimentsMap = (
  experiments: UntypedExperiment[]
): CombinedMaps => {
  const ExperimentsMap = experiments.reduce((acc, experiment) => {
    if (JsonExperiments.has(experiment.id)) {
      // JSON Experiments
      const { variantName, data } = JSON.parse(experiment.variant);

      acc[experiment.id] = {
        id: experiment.id,
        variant: variantName,
        data,
      };
    } else {
      // String Experiments
      acc[experiment.id] = experiment;
    }

    return acc;
  }, {} as Partial<CombinedMaps>) as CombinedMaps;

  return ExperimentsMap;
};

export const stripBusinessTrackingProperties = (
  trackingProperties: Map<string, string> | undefined
): Map<string, string> => {
  const source = (trackingProperties ?? {}) as unknown as Record<
    string,
    string
  >;
  if (!isCorpTenant(getConfigTenant())) {
    return source as unknown as Map<string, string>;
  }
  const filtered: Record<string, string> = {};
  for (const key of Object.keys(source)) {
    if (!(key in BUSINESS_EXPERIMENT_VARIANTS)) {
      filtered[key] = source[key];
    }
  }
  return filtered as unknown as Map<string, string>;
};

export const fetchActiveExperiments = async () => {
  const { data } = await axios.put(END_POINT, {}, { baseURL: config.baseURL });

  return {
    experiments: createExperimentsMap(data.experiments),

    trackingProperties: data.trackingProperties,
  };
};
